import { chatAPI } from "@api/chat";
import { processRequest } from "@api/config";

import { useAuthQuery } from "@lib/queryClient";

import { API_PREFIXES, QUERY_KEYS } from "@configs/api";

export const useGetEmojiListQuery = () =>
	useAuthQuery({
		queryKey: [QUERY_KEYS.EMOJI_LIST],
		queryFn: async () => {
			const data = await processRequest({
				prefix: API_PREFIXES.GET_EMOJI_LIST,
				request: (token) => chatAPI.getAllEmojisByModelAsync({ token }),
			});
			return data;
		},
	});
